export default __webpack_public_path__ + "static/media/EN_12.6e2dceaa.svg";